export default __webpack_public_path__ + "static/how-we-build-companies-horizontal-xs-1dd5aa9623d41d8fa2b429673bbcb416.svg";